import { Field, useFormState } from "react-final-form";
import { splitFieldProps } from "./splitFieldProps";
import classNames from "classnames";
import { get } from "lodash";

export function RadioBig({ className, children, ...props }) {
    return (
        <label
            className={classNames(
                "select-none w-full h-full px-2 py-6 inline-flex flex-col justify-center items-center text-[16px] cursor-pointer relative transition-colors duration-200 rounded-lg text-center bg-white shadow-[0_1px_8px_rgba(0,0,0,0.15)] font-bold",
                "has-[:checked]:text-secondary has-[:checked]:bg-[#F4F9FF] has-[:checked]:shadow-[0_1px_4px_2px_rgba(42,91,151,0.7)]",
                {},
                className
            )}
        >
            <input type="radio" className="hidden" {...props} />
            {children}
        </label>
    );
}

export function RadioBigField(props) {
    const [fieldProps, radioBigProps] = splitFieldProps(props);
    const { values } = useFormState();

    return (
        <Field
            {...fieldProps}
            type="radio"
            render={({ input, meta }) => (
                <RadioBig
                    {...radioBigProps}
                    {...input}
                    onChange={(e) => {
                        input.onChange(e);
                        radioBigProps.onChange?.(e);
                    }}
                    checked={input.checked && !!get(values, fieldProps.name)}
                >
                    {props.children}
                    {meta.touched && meta.error && <span>{meta.error}</span>}
                </RadioBig>
            )}
        />
    );
}
